export const CREATE_ORDER_TEMPLATE_TITLE_TEXT = {
    id: 'oe.blueprints.orderTemplate.create.title',
    defaultMessage: 'New Order Template',
    description: 'Popover header text',
};

export const EDIT_ORDER_TEMPLATE_TITLE_TEXT = {
    id: 'oe.blueprints.orderTemplate.edit.title',
    defaultMessage: 'Edit Order Template',
    description: 'Popover header text',
};

export const ORDER_TEMPLATE_PRELOAD_ERROR_TEXT = {
    id: 'oe.blueprints.orderTemplate.preloadError',
    defaultMessage: 'Unable to load order form data.',
    description: 'Shown when the Create Order preload fails while opening the template pop-up',
};
